import {
    columnKeyToParamColumn,
    columnsConfig,
} from '@/components/WellLoggingOperations/TabletSettings/ColumnSettings/config';

export const prepareStateWellColumns = (settings, additional) => {
    const {
        columnsVisibility,
        columnsSizing,
        wellLoggingKeys,
        curveSettings,
        curveDisplaySettings,
        columnsOrder,
        fgiParamsHistogramIds,
        rigisParamsHistogramIds,
        rigisColumnsCount,
        rigisColumnsOrder,
    } = settings;
    const { researches, geoVersions } = additional;

    const columnKeys = Object.keys(columnKeyToParamColumn);

    const columns = [];

    let totalWidth = 0;
    let idx = 0;

    for (const columnKey of columnKeys) {
        const { width } = columnsSizing[columnKey];
        let column = null;
        if (columnKey === 'carrotage') {
            const carrotageChildren = findActiveResearches(
                wellLoggingKeys,
                researches,
                curveSettings,
                curveDisplaySettings,
            );

            for (let i = 0; i < carrotageChildren.length; i++) {
                idx += 1;

                column = {
                    intParamValue: columnsVisibility[columnKey] ? 2 : 1,
                    paramIndex: idx,
                    paramNumber: carrotageChildren[i]?.param,
                    paramType: 7,
                    paramColumn: columnKeyToParamColumn[columnKey],
                    paramTitle: columnsConfig[columnKey],
                    paramWidth: width,
                    strParamValue:
                        carrotageChildren[i]?.strParamValue?.curveSettings ||
                        carrotageChildren[i]?.strParamValue?.curveSettings
                            ? prepareCurveSettingsObj(carrotageChildren[i]?.strParamValue)
                            : carrotageChildren[i].strParamValue,
                };

                if (!columns.some(col => col.paramNumber === column.paramNumber)) columns.push(column);
            }
        } else if (columnKey === 'geoObjects') {
            const versionsVisibilityArray = geoVersions.map(version => {
                return { id: version.stratumVersionId, visible: version.visible };
            });

            column = {
                intParamValue: columnsVisibility[columnKey] ? 2 : 1,
                paramIndex: idx,
                paramNumber: columnKeyToParamColumn[columnKey],
                paramType: columnKeyToParamColumn[columnKey],
                paramColumn: columnKeyToParamColumn[columnKey],
                paramTitle: columnsConfig[columnKey],
                paramWidth: width,
                strParamValue: JSON.stringify({
                    visible: columnsVisibility[columnKey] ? '1' : '0',
                    versions: versionsVisibilityArray,
                    columnsOrder: columnsOrder,
                    fgiParamsHistogramIds: fgiParamsHistogramIds,
                    rigisParamsHistogramIds: rigisParamsHistogramIds,
                    rigisColumnsCount: rigisColumnsCount,
                    rigisColumnsOrder: rigisColumnsOrder,
                }),
            };
            columns.push(column);
        } else {
            column = {
                intParamValue: columnsVisibility[columnKey] ? 2 : 1,
                paramIndex: idx,
                paramNumber: columnKeyToParamColumn[columnKey],
                paramType: columnKeyToParamColumn[columnKey],
                paramColumn: columnKeyToParamColumn[columnKey],
                paramTitle: columnsConfig[columnKey],
                paramWidth: width,
                strParamValue: columnsVisibility[columnKey] ? '1' : '0',
            };
            columns.push(column);
        }

        if (columnKey !== 'allGeoObjects') {
            totalWidth += width;
        }
        idx += 1;
    }

    return { totalWidth, columns };
};

/*
    Поиск кривых в исследованиях скважины. Необходимый параметр для сущности template.
*/
export const findActiveResearches = (wellLoggingKeys, researches, curveSettings, curveDisplaySettings) => {
    const result = [];

    if (researches) {
        researches.forEach(r1 => {
            r1.children.forEach(r2 => {
                r2.children.forEach(research => {
                    if (wellLoggingKeys.includes(research.key)) {
                        const strParamValue =
                            (curveSettings[research.key] && Object.keys(curveSettings[research.key]).length > 0) ||
                            (curveDisplaySettings[research.key] &&
                                Object.keys(curveDisplaySettings[research.key]).length > 0)
                                ? {
                                      curveSettings: curveSettings[research.key],
                                      curveDisplaySettings: curveDisplaySettings[research.key],
                                  }
                                : research.type;

                        result.push({
                            param: research.curve,
                            strParamValue: strParamValue,
                            paramTitle: research.title,
                            key: research.key,
                        });
                    }
                });
            });
        });
    }

    return result;
};

export const prepareActiveTabletColumns = (
    wellId,
    wellKey,
    tabletSettings,
    researches,
    geoVersions,
    emptyColumnsDataSettings,
    tooltipSettings,
    globalCurvesSettings,
    depthType,
) => {
    const { totalWidth, columns } = prepareStateWellColumns(tabletSettings, {
        researches: researches,
        geoVersions: geoVersions,
    });

    return {
        columnWidth: totalWidth,
        params: columns,
        wellId,
        activeGeoVersion: geoVersions[0]?.stratumVersionId,
        tooltipSettings: JSON.stringify(tooltipSettings),
        emptyColumnsDataSettings: emptyColumnsDataSettings,
        globalCurvesSettings: JSON.stringify(globalCurvesSettings),
        type: null,
        depthType: depthType,
    };
};

export const curveSettingsMap = {
    dashed: '1',
    title: '2',
    color: '3',
    description: '4',
    code: '5',
    key: '6',
    lineWidth: '7',
    lineType: '8',
    parentName: '9',
    lineDisplay: '10',
    // это поле есть только на фронте
    columnNum: '11',
    isChangeMinMaxValues: 12,
    isDecimalLog: 13,
    minMaxValues: 14,
};

export const curveDisplaySettingsMap = {
    isMirroring: '1',
    // Десятичный логарифм значений
    isDecimalLog: '2',

    // Ограничение глубин кривой
    isChangeMinMaxDepths: '3',
    minMaxValueType: '4',
    minMaxDepths: '5',

    // Изменение граничных точек
    isChangeMinMaxValues: '6',
    minMaxValues: '7',

    // Заливка области диаграммы
    isFilling: '8',
    fillingType: '9',

    // Раздел с масштабами активен
    isScales: '10',

    // Шаг кривой
    isCurveStep: '11',
    maxStep: '12',

    fillingValue: '13',
    fillingValueType: '14',
    isFillingOutside: '15',

    // Заливка между парой кривых
    isCurvesFilling: '16',
    curvesFillingType: '17',
    curvesFillingColor: '18',
    curvesFillingResearch: '19',
    childrenCurves: '20',
    scaleProps: '21',
};

const childCurve = {
    curve: '1',
    key: '2',
    parentCurve: 3,
    xStart: '4',
    xStep: '5',
    xStop: '6',
};

const scaleProps = {
    xStart: '1',
    xStep: '2',
    xStop: '3',
};

const minMaxDepths = {
    depthStart: '1',
    depthStop: '2',
    depthAbsStart: '3',
    depthAbsStop: '4',
};
const miMaxValues = {
    xStart: '1',
    xStop: '2',
};

const processValueMap = (obj, map, valueTransform = v => v) => {
    const result = {};

    for (const [k, v] of Object.entries(obj)) {
        const newKey = map[k];
        if (newKey) {
            result[newKey] = valueTransform(v, k);
        }
    }

    return result;
};

const processValueMapArray = (arr, map, valueTransform = v => v) => {
    if (!Array.isArray(arr)) return [];

    return arr.map(obj => {
        const result = {};
        for (const [k, v] of Object.entries(obj)) {
            const newKey = map[k];
            if (newKey) {
                result[newKey] = valueTransform(v, k);
            }
        }
        return result;
    });
};

export const prepareCurveSettingsObj = obj => {
    if (!obj.curveSettings && obj.globalCurvesSettings) obj.curveSettings = obj.globalCurvesSettings;

    if (!obj.curveSettings && !obj.curveDisplaySettings) return obj.toString();

    const updatedObj = {
        curveSettings: {},
        curveDisplaySettings: {},
    };

    const config = [
        {
            source: obj.curveSettings,
            target: updatedObj.curveSettings,
            map: curveSettingsMap,
        },
        {
            source: obj.curveDisplaySettings,
            target: updatedObj.curveDisplaySettings,
            map: curveDisplaySettingsMap,
        },
    ];

    for (const { source, target, map } of config) {
        if (!source) continue;

        for (const [key, value] of Object.entries(source)) {
            const newKey = map[key];
            if (!newKey) continue;

            if (value && typeof value === 'object' && Object.keys(value).length > 0) {
                let updatedValue = value;

                if (key === 'minMaxDepths') {
                    updatedValue = processValueMap(value, minMaxDepths, v => parseFloat(v).toFixed(2));
                } else if (key === 'miMaxValues') {
                    updatedValue = processValueMap(value, miMaxValues);
                } else if (key === 'childrenCurves') {
                    updatedValue = processValueMapArray(value, childCurve);
                } else if (key === 'scaleProps') {
                    updatedValue = processValueMap(value, scaleProps);
                }

                target[newKey] = updatedValue;
            } else {
                target[newKey] = value;
            }
        }
    }

    return JSON.stringify(updatedObj);
};

const reverseMap = map => {
    const reversed = {};
    for (const [key, value] of Object.entries(map)) {
        reversed[value] = key;
    }
    return reversed;
};

export const reverseCurveSettingsMap = reverseMap(curveSettingsMap);
export const reverseCurveDisplaySettingsMap = reverseMap(curveDisplaySettingsMap);
export const reverseMinMaxDepts = reverseMap(minMaxDepths);
export const reverseMiMaxValues = reverseMap(miMaxValues);
export const reverseChildCurve = reverseMap(childCurve);
export const reverseScaleProps = reverseMap(scaleProps);

export const restoreCurveSettingsObj = jsonString => {
    const parsedObj = JSON.parse(jsonString);
    const restoredObj = { curveSettings: {}, curveDisplaySettings: {} };

    const config = [
        {
            source: parsedObj.curveSettings,
            target: restoredObj.curveSettings,
            reverseMap: reverseCurveSettingsMap,
            nestedMaps: {
                [curveSettingsMap?.minMaxValues]: reverseMiMaxValues,
            },
        },
        {
            source: parsedObj.curveDisplaySettings,
            target: restoredObj.curveDisplaySettings,
            reverseMap: reverseCurveDisplaySettingsMap,
            nestedMaps: {
                [curveDisplaySettingsMap?.minMaxDepths]: reverseMinMaxDepts,
                [curveDisplaySettingsMap?.minMaxValues]: reverseMiMaxValues,
                [curveDisplaySettingsMap?.childrenCurves]: reverseChildCurve,
                [curveDisplaySettingsMap?.scaleProps]: reverseScaleProps,
            },
        },
    ];

    for (const { source, target, reverseMap, nestedMaps } of config) {
        if (!source) continue;

        for (const [key, value] of Object.entries(source)) {
            const originalKey = reverseMap[key];
            if (!originalKey) continue;

            const nestedMap = nestedMaps?.[key];

            if (nestedMap && typeof value === 'object' && value !== null) {
                if (Array.isArray(value)) {
                    target[originalKey] = value.map(item => {
                        const mappedItem = {};
                        for (const [subKey, subValue] of Object.entries(item)) {
                            const restoredSubKey = nestedMap[subKey];
                            if (restoredSubKey && restoredSubKey !== 'key') {
                                mappedItem[restoredSubKey] = Number(subValue);
                            } else mappedItem[restoredSubKey] = subValue;
                        }
                        return mappedItem;
                    });
                } else {
                    const restoredNested = {};
                    for (const [subKey, subValue] of Object.entries(value)) {
                        const restoredSubKey = nestedMap[subKey];
                        if (restoredSubKey) {
                            restoredNested[restoredSubKey] = Number(subValue);
                        }
                    }
                    target[originalKey] = restoredNested;
                }
            } else {
                target[originalKey] = value;
            }
        }
    }

    return restoredObj;
};
